var link_viewer_wrapper_default = {
  "anchor": "_9k8cw",
  "link": "nWC1s"
};
export {
  link_viewer_wrapper_default as default
};
//# sourceMappingURL=link-viewer-wrapper-scss.js.map
